import React from 'react';
import Wide1 from '../../assets/images/ico_train_w1.png';
import Wide2 from '../../assets/images/ico_train_w2.png';
import Wide3 from '../../assets/images/ico_train_w3.png';
import Wide4 from '../../assets/images/ico_train_w4.png';
import Wide5 from '../../assets/images/ico_train_w5.png';
import { TrainsType } from '../../apis/Transits.api';

interface props {
  trainData: TrainsType[];
  setDetailDisp: React.Dispatch<React.SetStateAction<TrainsType[] | undefined>>;
}

export const AnomalyTrain: React.FC<props> = (props) => {
  const { trainData, setDetailDisp } = props;
  const TrainColor = (course: number) => {
    switch (course) {
      case 1:
        return Wide1;
      case 2:
        return Wide2;
      case 3:
        return Wide3;
      case 4:
        return Wide4;
      case 5:
        return Wide5;
    }
  };

  const TrainFontColor = (course: number) => {
    switch (course) {
      case 1:
        return '#0000FF';
      case 2:
        return '#000000';
      case 3:
        return '#FF0000';
      case 4:
        return '#FF6600';
      case 5:
        return '#339900';
    }
  };

  return (
    <g
      onClick={() => {
        setDetailDisp(trainData);
      }}
      cursor='pointer'
    >
      <image
        key={`${'anomalyTrain' + trainData[0].id}`}
        x={trainData[0].x - 39}
        y={trainData[0].y - 94}
        xlinkHref={TrainColor(trainData[0].course)}
      ></image>
      <text
        fontSize='18'
        fontWeight='bold'
        x={
          trainData[0].train_no.toString().length === 3
            ? trainData[0].x - 16
            : trainData[0].x - 20
        }
        y={trainData[0].y - 68}
        fill={TrainFontColor(trainData[0].course)}
      >
        {trainData[0].train_no}
      </text>
    </g>
  );
};
